import type { CSSProperties } from 'react';

/** Compact, ratio-preserving thumbnails in the completed-image strip. */
export function chatImageSlotLayout({w,h}: {w:number;h:number}): CSSProperties {
  return {
    width: Math.round(w / h * 56),
    maxWidth: '100%',
    aspectRatio: `${w} / ${h}`,
    alignSelf: 'start',
  };
}
